import axiosCall from './interceptor';
import URL from '../helper';


export const getSearchMetaKeys = async (jobId) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/keys/${jobId}`;
  let response = await axiosCall('get', url); 
  return response.data ;
}

export const getJobRecords = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/search`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const handleApproval = async (payload) => {
  const url = `${URL.TRACKING_SYSTEM_URL}approvalProcess`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const getJobStats = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/stats`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const getJobRecordDataset = async (transactionId, channel) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/payload/${transactionId}?channel=${channel}`;
  let response = await axiosCall('get', url); 
  return response.data ;
}

export const getChannelStats = async (payload) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/stats2`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

// This API will allow processing without approval or re-initiating jobs.
export const handleApprovalProcess = async ({ jobId, proceedWithoutApproval }) => {
  const url = `${URL.BATCH_SYSTEM_URL}reInitiateJob?jobId=${jobId}&proceedWithoutApproval=${proceedWithoutApproval}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const postExclusions = async (payload) => {
  const url = `${URL.TRACKING_SYSTEM_URL}metadata/exclusion`;
  let response = await axiosCall('post', url, payload); 
  return response.data ;
}

export const getExclusions = async (jobId) => {
  const url = `${URL.TRACKING_SYSTEM_URL}metadata/exclusion?jobId=${jobId}`;
  let response = await axiosCall('get', url); 
  return response.data;
}

export const sendForPrinting = async ( payload ) => {
  const url = `${URL.BATCH_SYSTEM_URL}sendPrint`;
  let response = await axiosCall('post', url, payload); 
  return response.data;
}

export const fetchExclusionsData = async ( payload ) => {
  const url = `${URL.BATCH_SYSTEM_URL}metadata/exclusions`;
  let response = await axiosCall('post', url, payload); 
  return response.data;
}

export const getPrintBatchList = async ( jobId, printStatus ) => {
  const url = `${URL.BATCH_SYSTEM_URL}printBatch?jobId=${jobId}&printStatus=${printStatus}`;
  let response = await axiosCall('get', url); 
  return response.data;
}